// removed by extract-text-webpack-plugin
module.exports = {"horizontal":"theme__horizontal___1MJ9B","vertical":"theme__vertical___xUlwz"};


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/navigation/theme.css
// module id = 1446
// module chunks = 0